import { cn } from '../../../lib/cn';
import { hashKey, roleInitials } from '../../../lib/role-avatar';

/** Tám tông cho avatar người thực hiện, băm theo tên (§8.3). */
const USER_TONES = [
  'bg-primary-500',
  'bg-violet-500',
  'bg-teal-600',
  'bg-sky-600',
  'bg-orange-500',
  'bg-success-600',
  'bg-warning-500',
  'bg-danger-500',
] as const;

/** Ô người thực hiện: avatar chữ viết tắt + tên. */
export function UserCell({ name }: { name: string }) {
  const tone = USER_TONES[hashKey(name) % USER_TONES.length] ?? USER_TONES[0];
  return (
    <div className="flex items-center gap-2">
      <span
        className={cn(
          'grid h-6 w-6 shrink-0 place-items-center rounded-full text-2xs font-bold text-white',
          tone,
        )}
      >
        {roleInitials(name)}
      </span>
      <span className="truncate text-xs text-content-secondary">{name}</span>
    </div>
  );
}
